import { render, staticRenderFns } from "./DataVersionRecord.vue?vue&type=template&id=8a511492&scoped=true"
import script from "./DataVersionRecord.vue?vue&type=script&lang=js"
export * from "./DataVersionRecord.vue?vue&type=script&lang=js"
import style0 from "./DataVersionRecord.vue?vue&type=style&index=0&id=8a511492&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a511492",
  null
  
)

export default component.exports